import logo from "./logo.png";
import background from "./bg.png";
import banner from "./banner.jpg";
import empty from "./empty.png";
import notFound from "./notFound.png";
import paymentSuccess from "./paymentSuccess.gif";
import noufound from "./noufound.gif";
import error from "./error.gif";
import vip from "./vip.png";

export {
  background,
  banner,
  empty,
  notFound,
  paymentSuccess,
  noufound,
  error,
  vip,
};

export default logo;
